export const GET_ADS = 'GET_ADS';
export const GET_ADS_BY_CATEGORY = 'GET_ADS_BY_CATEGORY';
export const GET_ADS_BY_ID = 'GET_ADS_BY_ID';
export const ADD_ADS = 'ADD_AD';
export const DELETE_ADS = 'DELETE_AD';
export const ADS_LOADING = 'ADS_LOADING';



// WEBPACK FOOTER //
// ./src/store/actions/types.js